<template>
  <q-tab-panel :class="`${noMobilePadding ? 'no-mobile-padding' : ''}`" :name="name">
    <slot />
  </q-tab-panel>
</template>

<script>
export default {
  name: 'TabPanel',
  props: {
    name: String,
    noMobilePadding: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="stylus" scoped>
.no-mobile-padding {
  padding: 0;

  @media (min-width: $breakpoint-sm) {
    padding: $space-md['x'];
  }
}
</style>
